import React from "react";
import "./VisionMissionBlock.css";

function VisionMissionBlock({ title, cards }) {
  return (
    <section className="block block7">

      <h2 className="block7-title">{title || ''}</h2>

      <div className="block7-cards">
        {(cards || []).map((card, index) => (
          <div key={index} className="block7-card">
            {card.icon && <img src={card.icon} alt={card.heading || ''} />}
            <h3>{card.heading || ''}</h3>
            <div className="card-line"></div>
            <p>{card.text || ''}</p>
          </div>
        ))}
      </div>

    </section>
  );
}

export default VisionMissionBlock;
